import { COND, OP } from "../../../misc/RuleObjectTypes";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { RulesContext } from "../../../RulesContext";
import { filterReducer } from "../../../misc/FilterReducer";
import _ from "lodash";
import FilterCondition from "./FilterCondition";
import FilterOperator from "./FilterOperator";
import { Link } from "react-router-dom";

export const initialState = {
  localFilters: [
    { type: COND, attrID: 0, AttrValueId: 0, conditionOperator: 4 },
  ],
};


const Filters = ({ attributesList, filters, side, rulePos, savedFilters }) => {
  const { ruleDispatch, selectedCategory } = useContext(RulesContext);
  let [filterSet, reduceFilters] = useReducer(filterReducer, {
    localFilters: filters,
  });

  const [disableApplyFilter, setDisableApplyFilter] = useState(false);

  const categoryAttributeSet = attributesList && attributesList;

  useEffect(() => {
    let filteredArray = _.filter(
      filterSet.localFilters,
      (item) =>
        item.AttrValueId === 0 ||
        item.conditionOperator === 0 ||
        item.attrID === 0
    );
    if (filteredArray.length > 0) {
      setDisableApplyFilter(true);
    } else {
      setDisableApplyFilter(false);
    }
  });

  const clearFilters = () => {
    reduceFilters({
      type: "SET_FILTERS",
      filters: [
        {
          type: "Condition",
          attrID: 0,
          AttrValueId: 0,
          conditionOperator: 0,
        },
      ],
    });
    ruleDispatch({
      type: "APPLY_FILTERS",
      side: side,
      filtersArray: [
        {
          type: "Condition",
          attrID: 0,
          AttrValueId: 0,
          conditionOperator: 0,
        },
      ],
      position: rulePos,
    });
  }

  const applyFilters = () => {
    ruleDispatch({
      type: "APPLY_FILTERS",
      side: side,
      filtersArray: filterSet.localFilters,
      position: rulePos,
    });
  }

  return (
    <div
      className="modal fade "
      id={`staticBackdrop-${rulePos}-${side}`}
      data-bs-backdrop="false"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="tw-bg-black tw-bg-opacity-50 tw-absolute tw-h-max tw-w-full tw-min-h-screen">
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className="modal-dialog modal-xl modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="filter-section">
                  {filterSet.localFilters &&
                  filterSet.localFilters.length > 0 ? (
                    filterSet.localFilters.map((element, position) => {
                      if (element.type === COND) {
                        return (
                          <FilterCondition
                            {...{
                              element,
                              position,
                              reduceFilters,
                              categoryAttributeSet,
                              filterCount: filterSet.localFilters.length,
                            }}
                            key={position}
                          />
                        );
                      } else if (element.type === OP)
                        return (
                          <FilterOperator
                            {...{
                              element,
                              position,
                              reduceFilters,
                            }}
                            key={position}
                          />
                        );
                    })
                  ) : (
                    <FilterCondition
                      {...{
                        reduceFilters,
                        categoryAttributeSet,
                        filterCount: 0,
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="modal-footer tw-flex tw-justify-end tw-gap-2">
                <Link
                  href="#"
                  className="link-primary tw-font-medium tw-text-xs tw-text-[#091caa]"
                  data-bs-dismiss="modal"
                >
                  Close
                </Link>
                <button
                  type="button"
                  className="outline-button"
                  data-bs-dismiss="modal"
                  onClick={clearFilters}
                >
                  Clear Filter(s)
                </button>

                <button
                  type="button"
                  className="button-style "
                  data-bs-dismiss="modal"
                  disabled={disableApplyFilter}
                  onClick={applyFilters}
                >
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filters;
